module.exports = __webpack_public_path__ + "static/section4-f6350e36c9186f7ad3f9de06ee149d87.png";